export function neverReached(value: never): never {
  throw new Error(`Unexpected value reached exhaustive check: ${String(value)}`);
}
